module.exports = __webpack_public_path__ + "static/media/event_available.03d6f9d1.svg";